(function ($, Global) {
    var plausible = Global.plausible || function () { };
    var ModalCookieConsent = function (selector, selectorSettings) {
        this.selector = selector;
        this.selectorSettings = selectorSettings;
        this.$el = $(selector);
        this.$cookieSettings = $(selectorSettings);
        this.cookieManager = new Global.CookieManager();
    };

    ModalCookieConsent.prototype.initEvents = function () {
        this.publishers();
        this.subscribers();
    }

    ModalCookieConsent.prototype.publishers = function () {
        var self = this;
        $(document).ready(function () {
            self.$el.modal({
                backdrop: 'static',
                show: true
            });
        });
        $(document).on('click', this.selector + ' .btn-accept', function () {
            self.dispatchEvent("Accepter", "Cookie - tout accepter")
            self.cookieManager.approve(self.cookieManager.allServices);
        });
        $(document).on('click', this.selector + ' .btn-settings', function () {
            self.dispatchEvent("Paramètrer", "Cookie - parametrer")
            self.$cookieSettings.modal({
                backdrop: 'static',
                show: true
            });
        });
        $(document).on('click', this.selector + ' .btn-continue', function () {
            $.Topic("Cookie-deny").publish();
        });
        $(document).on('shown.bs.modal', this.selector, function () {
            if ($(this).is(':visible')) {
                self.dispatchEvent("AffichageMessage", "Cookie - affichage du message")
            } else {
                $(this).modal('hide')
            }
        });

    }
    ModalCookieConsent.prototype.subscribers = function () {
        var self = this;
        $.Topic("Cookie-deny").subscribe(function () {
            self.dispatchEvent("Continuer", "Cookie - continuer sans accepter")
            var services = self.cookieManager.servicesActivate();
            self.cookieManager.approve(services.filter(function (s) { return s === 'oneSignal' }));
        })
    }
    ModalCookieConsent.prototype.dispatchEvent = function (type, label) {
        plausible(label)
        document.dispatchEvent(
            new CustomEvent("EventCookieConsent", {
                detail: {
                    type: type,
                    label: label
                }
            })
        )
    }

    Global.ModalCookieConsent = ModalCookieConsent;
}(jQuery, window));